import { Tooltip } from "antd";
import styles from "./chatAudioRecording.module.scss";
import recwave from "../../../../styles/images/recwave.svg";
import React, { useEffect } from 'react';
import store from "../../../../context/store/store";
import { Types } from "../../../../context/action/action";

let interval: any;


type voiceRecorderProps = {
  closeRecorder: Function;
  convertAudio: Function;
}

export default function ChatAudioRecording({closeRecorder, convertAudio}:voiceRecorderProps) {

  const startTimer = () => {
    
    interval = setInterval(() => {
    
      let Timer = store.getState().chatReducer.recordingTimer || "00:00:00";
      let ss:any = Timer.split(":");
      let dt = new Date();
      dt.setHours(ss[0]);
      dt.setMinutes(ss[1]);
      dt.setSeconds(ss[2]);

      let dt2 = new Date(dt.valueOf() + 1000);
      let temp = dt2.toTimeString().split(" ");
      let ts = temp[0].split(":");
      let timer: any;

      timer = ts[0] + ":" + ts[1] + ":" + ts[2];
      store.dispatch({
        type: Types.AUDIO_RECORD_TIMER,
        payload: {
          recordingTimer:timer
        }
      });
    }, 1000);
  };

  
  const clearRunningTimer = () => {
    clearInterval(interval);
    interval = undefined;
    store.dispatch({
      type: Types.AUDIO_RECORD_TIMER,
      payload: {
        recordingTimer:"00:00:00"
      }
    });
  };

  useEffect(() => {
   
    startTimer();
    return () => {
      clearRunningTimer();
    };
  },[]);


  
  let TimerVal = store.getState().chatReducer.recordingTimer || "00:00:00:";

  return (
    <>
      <div className={styles.chatAudioRecording}>
        <Tooltip mouseEnterDelay={0.5}  placement="top" title={'Cancel'} >
          <span className={styles.closeIcon} onClick={ ()=>closeRecorder()}></span></Tooltip>
        <span className={styles.timerCount}>{TimerVal}</span>
        <Tooltip mouseEnterDelay={0.5} placement="top" title={'OK'}><span className={styles.tickIcon} onClick={()=>convertAudio()}></span></Tooltip>
        <div className={styles.waveImg}>
          <img src={recwave} alt="" />
        </div>
      </div>
    </>
  );
};
